import ReactDOM from "react-dom/client"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

/* HTTP */
import axios from "axios"
import { apiOffset } from "./helpers/timezone"

/* Redux */
import { Provider } from "react-redux"
import { store } from "./store"

/* CSS */
import "./design/css/app.css"
import "./design/css/dashboard.css"
import "./design/css/auth.css"
import "./design/css/input.css"
import "./design/css/menu.css"
import "./design/css/pitboard.css"
import "./design/css/timezone.css"
import "./design/css/header.css"
import "./design/css/chat.css"
import "./design/css/profile.css"
import "./design/css/notification.css"
import "./design/css/page404.css"
import "./design/css/page.css"
import "./design/css/report.css"
import "./design/css/layout.css"
import "./design/css/pagination.css"
import "./design/css/toast.css"
import "./design/css/confirm.css"
import "./design/css/game.css"
import "./design/css/reload.css"
import "react-datepicker/dist/react-datepicker.css"
import "./design/css/table.css"
import "./design/css/bonus.css"
import "./design/css/dealer.css"
import "./design/css/currency.css"
import "./design/css/operator.css"
import "./design/css/studio-filter.css"
import "./design/css/chip.css"
import "./design/css/studio.css"
import "./design/css/studios.css"
import "./design/css/manager.css"

import "./design/css/multipoker.css"
import "./design/css/puntobanco.css"
import "./design/css/vippoker.css"
import "./design/css/roulette.css"
import "./design/css/vipthreebox.css"

import "./design/css/electron.css"

import "./design/css/player.css"
import "./design/css/players.css"
import "./design/css/process.css"
import "./design/css/transaction.css"
import "./design/css/cards.css"
import "./design/css/refund.css"
import "./design/css/video.css"
import "./design/css/game-player.css"
import "./design/css/notes.css"
import "./design/css/dsh-notes.css"
import "./design/css/messages.css"
import "./design/css/transactions.css"
import "./design/css/bookings.css"
import "./design/css/bonuses.css"
import "./design/css/statistics.css"
import "./design/css/game-filter.css"
import "./design/css/game-list.css"
import "./design/css/round.css"
import "./design/css/rsg.css"
import "./design/css/logs.css"
import "./design/css/card.css"


/* Attach the selected timezone offset to every request body (backend converts date ranges to UTC) */
axios.interceptors.request.use((config) => {
    if (config.data && typeof config.data === "object" && !(config.data instanceof FormData)) {
        config.data = { ...config.data, timezone: apiOffset() }
    }
    return config
})

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <Provider store={store}>
        <App />
    </Provider>
)

reportWebVitals()
